var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGridChange3ColActive = function SvgIconGridChange3ColActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.666 2.5a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h4.667a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1zm4.333 1.667H3v11.666h4zM12.666 2.5a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h4.667a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1zm4.333 1.667h-4v11.666h4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.666 2.5a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h4.667a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1zm4.333 1.667H8v11.666h4z",
    clipRule: "evenodd"
  })));
};
export default SvgIconGridChange3ColActive;